<ng-container *transloco="let t">
  <div class="flex flex-col gap-y-4">
    <div class="text-gray-800">
      {{
        modalData.segmentType === SegmentType.KeywordSegment
          ? t("add-to-segment-modal.target_search_term", { count: targetingItemValues.length })
          : t("add-to-segment-modal.target_product", { count: targetingItemValues.length })
      }}
    </div>

    @if (modalData.segmentType === SegmentType.ProductSegment) {
      <div>
        @for (targetingItemValue of targetingItemValues.slice(0, 3); track targetingItemValue; let last = $last) {
          <app-product-view [asin]="targetingItemValue" [marketplace]="modalData.marketplace"></app-product-view>
        }
      </div>
    }
    @if (modalData.segmentType === SegmentType.KeywordSegment) {
      <div class="text-gray-600">
        @for (targetingItemValue of targetingItemValues.slice(0, 3); track targetingItemValue; let last = $last) {
          <span>{{ targetingItemValue }}{{ last ? "" : ", " }}</span>
        }
        @if (targetingItemValues.length > 3) {
          <span>…</span>
        }
      </div>
      <div class="flex justify-end">
        <ISwitchButton
          [options]="[MatchType.phrase, MatchType.exact]"
          [buttonTexts]="['common.phrase', 'common.exact']"
          [buttonTooltips]="['', '']"
          [selected]="matchType"
          (buttonClicked)="setMatchType($event)"
        />
      </div>
    }
    <label class="text-gray-800">{{ t("common.segment") }}</label>
    <div>
      <ISelectMenu
        [value]="selectedSegment()"
        (valueChange)="selectSegment($event)"
        [(searchQuery)]="searchQuery"
        fitTriggerWidth
      >
        <ISelectTrigger class="flex w-full">
          <ISelectValue>
            <div *iSelectValue="let value" class="flex">
              @if (value === CREATE_NEW_SEGMENT) {
                <span class="text-main inline-flex items-center gap-x-2 truncate">
                  <IIcon name="add" class="text-lg" />
                  {{ t("add-to-segment-modal.create_new_segment") }}
                </span>
              } @else {
                <span class="inline-flex w-full justify-between truncate text-gray-700">
                  {{ value.name }}
                  <IBadge
                    variant="soft"
                    [label]="
                      value.segmentType === SegmentType.KeywordSegment ? t('common.keyword') : t('common.product')
                    "
                    size="xs"
                  />
                </span>
              }
            </div>
          </ISelectValue>
        </ISelectTrigger>
        <ISelectContent>
          <ISelectOption [value]="CREATE_NEW_SEGMENT">
            <span class="text-main flex items-center gap-x-2 truncate">
              <IIcon name="add" class="text-lg" />
              {{ t("add-to-segment-modal.create_new_segment") }}
            </span>
          </ISelectOption>
          @for (segment of filteredSegments(); track segment.segmentId) {
            <ISelectOption [value]="segment">
              <span class="inline-flex w-full justify-between truncate text-gray-700">
                {{ segment.name }}
                <IBadge
                  variant="soft"
                  [label]="
                    segment.segmentType === SegmentType.KeywordSegment ? t('common.keyword') : t('common.product')
                  "
                  size="xs"
                />
              </span>
            </ISelectOption>
          }
        </ISelectContent>
      </ISelectMenu>
    </div>
    <div class="flex justify-end gap-x-2">
      <button iButton variant="secondary" (click)="close()">
        {{ t("common.cancel") }}
      </button>
      <button iButton (click)="save()">
        {{ t("common.save") }}
      </button>
    </div>
  </div>
</ng-container>
